import React from "react";
import { Card, CardContent, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";

export function FinanceAdsComparisonTable({ current, compare }) {
  if (!current) return null;

  const rows = [
    { label: "Ventas (Publicidad)", current: current.sales_pen, compare: compare?.sales_pen },
    { label: "Gasto (Publicidad)", current: current.expenses_pen, compare: compare?.expenses_pen },
    { label: "Neto (Ventas - Gasto)", current: current.net_pen, compare: compare?.net_pen },
    { label: "N° Ventas Ads", current: current.sales_count, compare: compare?.sales_count, isCount: true },
    { label: "N° Gastos Pub", current: current.expenses_count, compare: compare?.expenses_count, isCount: true },
  ];

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Publicidad: Ventas vs Gasto
        </Typography>

        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Concepto</TableCell>
                <TableCell align="right">Actual</TableCell>
                <TableCell align="right">Comparativo</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.label} hover>
                  <TableCell>{r.label}</TableCell>
                  <TableCell align="right">
                    {r.isCount ? String(r.current ?? 0) : formatPen(r.current)}
                  </TableCell>
                  <TableCell align="right">
                    {r.compare == null
                      ? "—"
                      : r.isCount
                      ? String(r.compare ?? 0)
                      : formatPen(r.compare)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
